import React from "react";
import Loadable from "../../react-loadable";
import * as Util from "./util";

const WeaAuth = Loadable({
  loader: () => import("./Auth"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
WeaAuth.util = Util;

export default WeaAuth;



// WEBPACK FOOTER //
// ./ecology9/wea-auth/index.js